var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16V3C1 1.89543 1.89543 1 3 1H8.22203C8.72242 1 9.20462 1.18757 9.57348 1.52569L14.3514 5.9055C14.7647 6.28431 15 6.81919 15 7.3798V16",
    stroke: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1V6.5H14.5",
    stroke: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6667L6.42836 16.8743C7.145 17.5258 8.22547 17.5702 8.99313 16.9796L12 14.6667",
    stroke: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13V17.6667",
    stroke: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcel);
export default __webpack_public_path__ + "static/media/exportExcel.7acdc8f72fcb69b802ea2804ddf0c1fd.svg";
export { ForwardRef as ReactComponent };